export default __webpack_public_path__ + "static/media/event.inline.1a2297e0.svg";